var _defs, _rect, _polygon, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1317 79.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-1{opacity:0;}.cls-2{fill:#e06b30;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.05,
    width: 1317,
    height: 79
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "245.67 79.07 0.42 79.07 27.22 39.53 0.42 0 245.67 0 272.48 39.53 245.67 79.07"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.05,49.84A9.78,9.78,0,0,1,81.29,58q-3.75,3-10.37,3A24.8,24.8,0,0,1,60.1,59V53a29.39,29.39,0,0,0,5.67,2,23.91,23.91,0,0,0,5.58.72c2.52,0,4.39-.48,5.58-1.44a4.7,4.7,0,0,0,1.8-3.86,4.84,4.84,0,0,0-1.65-3.71c-1.1-1-3.38-2.21-6.82-3.6a18.65,18.65,0,0,1-7.52-5.05,10.47,10.47,0,0,1-2.18-6.66A9.33,9.33,0,0,1,64,23.69q3.47-2.79,9.3-2.79a27.19,27.19,0,0,1,11.16,2.45l-2,5.19a24.39,24.39,0,0,0-9.28-2.18,7.11,7.11,0,0,0-4.69,1.35,4.44,4.44,0,0,0-1.6,3.55,5.12,5.12,0,0,0,.64,2.6,6.51,6.51,0,0,0,2.11,2,35.54,35.54,0,0,0,5.28,2.53,29.13,29.13,0,0,1,6.29,3.33,10.09,10.09,0,0,1,2.93,3.49A10.53,10.53,0,0,1,85.05,49.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.05,60.42H99.68V26.92H88.22V21.46h29.29v5.46H106.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.52,60.42h-22v-39h22V26.8H129.85V37.45h14.68v5.33H129.85V55.05h15.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.74,33.24q0,6.09-4,9.35t-11.38,3.25h-4.05V60.42h-6.37v-39h11.22q7.31,0,10.94,3T179.74,33.24Zm-19.43,7.24h3.38c3.27,0,5.67-.56,7.2-1.7a6.18,6.18,0,0,0,2.29-5.33,6,6,0,0,0-2.05-5c-1.37-1.1-3.51-1.65-6.4-1.65h-4.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.34,60.42h-6.26V35.26q0-4.5.21-7.14c-.41.42-.91.9-1.5,1.41s-2.59,2.15-6,4.9l-3.14-4,11.46-9h5.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepOne);
export default __webpack_public_path__ + "static/media/step-one.0789cd4c16d81fc048230d82f65d48a3.svg";
export { ForwardRef as ReactComponent };